import { Box, Button, Modal, Grid, Typography } from "@mui/material";
import { updateFutureUserPremium } from "services/mobile-app.service";


function FinalizePremiumUser({ toEdit, close, visible, refresh }: any) {
  const finalizeUser = async (id: any) => {
    await updateFutureUserPremium({ id: id, finalize:true, email:toEdit.email });
    await refresh();
    close();
  };
  
  return (
    <Modal open={visible}>
      <Box sx={minorStyle}>
        <Grid container flexDirection={"row"}>
          <Grid container p={1}>
            <Grid item>
              <Typography variant="h6" color={"black"}>
                Seguro que quieres finalizar este premium/plus?
              </Typography>
              <Typography variant="h6" color={"black"}>
                Email: {toEdit?.email}
              </Typography>

            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6} p={1}>
              <Button
                variant="contained"
                fullWidth
                onClick={()=>finalizeUser(toEdit.id)}
              >
                Si
              </Button>
            </Grid>
            <Grid item xs={6} p={1}>
              <Button variant="contained" fullWidth onClick={close}>
                Cerrar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

const minorStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  bgcolor: "white",
  p: 4,
  display: "flex",
  flexDirection: "column",
  transform: "translate(-50%, -50%)",
  // minWidth:'70%'
};

export { FinalizePremiumUser };
